$(document).ready(function(){

	// Mobile step next button
	$('.mobile__step .form__step .next__button').on('click' ,function(e){
		e.preventDefault();
		if ($('.mobile__step .form__step .active__input').next('.group__input').length) {
			$('.mobile__step .form__step .active__input').css("display" , "none").removeClass('active__input')	
																																																		.next().fadeIn(300).addClass("active__input");
		} else{
			$(this).closest('.mobile__step').css("display" ,"none")
																												  .next(".mobile__step").fadeIn(300);
		}
	});

	$('.mobile__step .main__step .next__button').on("click"  ,function(e){
		e.preventDefault();
		$(this).closest('.mobile__step').css("display"  ,"none")
																											   .next('.mobile__step').fadeIn(300);
	});

	$('.mobile__step .step__bracelet .next__button').on("click"  ,function(e){
		e.preventDefault();
		$(this).closest('.mobile__step').css("display"  ,"none")
																											   .next('.mobile__step').fadeIn(300);
	});

	$('.mobile__step .notes__step .next__button').on("click"  ,function(e){
		e.preventDefault();
		$(this).closest('.mobile__step').css("display"  ,"none")
																											   .next('.mobile__step').fadeIn(300);
	});






	// Check if user enter the page from mobile/desktop version and show different versions
	if ($(window).width() > 1200) {
		// $('.desktop__version').fadeIn(300);		
		// $('.mobile__version').css('display' , 'none');
	} else {
		// $('.mobile__version').fadeIn(300);
		// $('.desktop__version').css("display" , 'none');
	}
	$(window).on("resize" , function(){
		if ($(window).width() > 1200) {
			// $('.desktop__version').fadeIn(300);
			// $('.mobile__version').css('display' , 'none');
		} else {
			// $('.mobile__version').fadeIn(300);
			// $('.desktop__version').css("display" , 'none');
		}
	});



	// Desktop step next button , individual for each in case we will need validation
	$('.desktop__step .main__step .next__button').on('click' ,function(e){
		e.preventDefault();
		$(this).closest('.desktop__step').css("display" , "none")
																												 .next(".desktop__step").fadeIn(500);
	});
	$('.desktop__step .step__form .next__button').on('click' ,function(e){
		e.preventDefault();
		$(this).closest('.desktop__step').css("display" , "none")
																												  .next(".desktop__step").fadeIn(500);
	});
	$('.desktop__step .step__bracelet .next__button').on('click' ,function(e){
		e.preventDefault();
		$(this).closest('.desktop__step').css("display" , "none")
																												  .next(".desktop__step").fadeIn(500);
	});

	$('.desktop__step .notes__step .next__button').on('click' ,function(e){
		e.preventDefault();
		$(this).closest('.desktop__step').css("display" , "none")
																												  .next(".desktop__step").fadeIn(500);
	});






	// JS to create containers full height of a viewport screen
	$('.mobile__step .inner__step').css("min-height" , "768px" );
	// $('.mobile__step .inner__step').css("min-height" , $(window).height() - 100 );
	$(window).on("resize" ,function(){
		$('.mobile__step .inner__step').css("min-height" , "768px");
		// $('.mobile__step .inner__step').css("min-height" , $(window).height() - 100);
	})

	$('.desktop__version').css("height" , $(window).height() - 1);
	$(window).on("resize" ,function(){
		$('.desktop__version').css("height" , $(window).height() - 1);
	})





	// Only numbers in .numeric fields
	$(document).on("input", ".numeric", function() 	{
	    this.value = this.value.replace(/\D/g,'');
	});


	//  On click at text checkbox switcher will change it state
	$('.switcher>p').on('click' ,function(){
		if ($(this).closest('.switcher').find("input").prop('checked') == true) {
			$(this).closest('.switcher').find("input").prop('checked',false);
		}else {
			$(this).closest('.switcher').find("input").prop('checked', true);
		}
	});

	// Bracelet circle styles for mobile version
	if ($('.mobile__step').length) {
		if ($(window).width() >= 1441) {
			smallstatus =  "320px"
		} 
        else if ($(window).width() >= 1201 && $(window).width() < 1441) {
            smallstatus =  "240px"
        }
        else if ($(window).width() >= 481 && $(window).width() < 1201) {
			smallstatus =  "220px"
        }
        else{
            smallstatus =  "143px"
        }

    if ($.isFunction($.fn.incircle)) {
		$('.mobile__step .bracelet__box .bracelet__inner').incircle({
			  type :0.95,
			  top:'-30px',
			  left:'0px',
			  radius:smallstatus,
			  start : -83
		});
  } else {
    // Reload the page if incircle is not a function
    location.reload();
  }

	}
	$(window).on('resize' ,function(){
			if ($(window).width() >= 1441) {
				smallstatus =  "320px"
			} 
             else if ($(window).width() >= 1201 && $(window).width() < 1441) {
                smallstatus =  "240px"
            }
             else if ($(window).width() >= 481 && $(window).width() < 1201) {
				smallstatus =  "220px"
			}
            else{
				smallstatus =  "143px"
            }
      
			$('.mobile__step .bracelet__box .bracelet__inner').incircle({
				  type :0.95,
				  top:'-30px',
				  left:'0px',
				  radius:smallstatus,
				  start : -83
			});
		});



	// Bracelet circle styles for desktop version
	if ($('.desktop__step .bracelet__inner').length) {
		let status;
		if ($(window).width() > 1440) {
			status =  "320px"
		} else{
			status =  "240px"
		}
		$(window).on('resize' ,function(){
			if ($(window).width() > 1440) {
				status =  "320px"
			} else{
				status =  "240px"
			}
		});
		$('.desktop__step .bracelet__inner').incircle({
			  type :0.95,
			  top:'0px',
			  left:'0px',
			  radius:status,
			  start : -83
		});
		$(window).on('resize' ,function(){
			$('.desktop__step .bracelet__inner').incircle({
			  type :0.95,
			  top:'0px',
			  left:'0px',
			  radius:status,
			  start : -83

			});
		});
	}
	let  timer;
	$('body').on("click"  ,  '.bracelet__inner span' ,function(){
		if ($(this).hasClass('selected')) {
			$(this).closest('.bracelet__inner').find("span[data-group="+ $(this).attr("data-group") +"]").removeClass("selected");

			//Deselected an area---------------
            ChangePatternOfGroup($(this).attr("data-group"));
			//---------------------------------

			if (timer) {
				clearTimeout(timer);
				timer = setTimeout(function(){
					$('.float__box').css("bottom" ,"-120px");
					$('body').removeClass("float");
				},1500);
			} else{
				clearTimeout(timer);
				timer = setTimeout(function(){
					$('.float__box').css("bottom" ,"-120px");
					$('body').removeClass("float");
				},1500);
			}
		} else {
			if ($(this).closest(".bracelet__inner").find("span.selected").length && $(this).attr("data-group")) {

				console.log($(this).closest('.bracelet__inner').find("span[data-group="+ $(this).attr("data-group") +"]"));
				console.log($(this).closest(".bracelet__inner").find("span.selected"));

				let groupCounter  =  $(this).closest('.bracelet__inner').find("span.selected").length;
				let  indexSelected  = $(this).closest('.bracelet__inner').find("span.selected").eq(groupCounter - 1);
				$(this).closest('.bracelet__inner').find("span.selected").addClass("picked");
				let groupCounterFinal = $(this).closest('.bracelet__inner').find("span[data-group="+ $(this).attr("data-group") +"]").length;
				$(this).closest('.bracelet__inner').find("span[data-group="+ $(this).attr("data-group") +"]").addClass("picked");
				let indexFinal = $(this).closest('.bracelet__inner').find("span[data-group="+ $(this).attr("data-group") +"]").eq(groupCounterFinal - 1);
				$($(this).closest('.bracelet__inner').find("span.selected").get()).each(function(index,elem) {
					let newClone = $(elem).clone();
					$(newClone).removeClass("picked");
					$(newClone).removeClass('selected');
					$(newClone).insertAfter(indexFinal);
				});
				$($(this).closest('.bracelet__inner').find("span[data-group="+ $(this).attr("data-group") +"]").get()).each(function(index,elem) {
					let newClone = $(elem).clone();
					$(newClone).removeClass("picked");
					$(newClone).removeClass('selected');
					$(newClone).insertAfter(indexSelected);
				});
				$(this).closest('.bracelet__inner').find('.picked').remove();
				$(window).trigger("resize");

				
				if (timer) {
					clearTimeout(timer);
					timer = setTimeout(function(){
						$('.float__box').css("bottom" ,"-120px");
						$('body').removeClass("float");
					},1500);
				} else{
					clearTimeout(timer);
					timer = setTimeout(function(){
						$('.float__box').css("bottom" ,"-120px");
						$('body').removeClass("float");
					},1500);
				}
			} else {
				if (timer) {
					clearTimeout(timer);
				}
				$('.float__box').css("bottom" ,"0px");
				$('body').addClass("float");
				$(this).closest('.bracelet__inner').find("span[data-group="+ $(this).attr("data-group") +"]").addClass("selected");
			}
		}
	});

});

// n's code
$(document).ready(function(){
    // Iterate over each planetList
    $(".planetList").each(function() {
        var list = $(this).find("li");
        var numToShow = 4;
        var button = $(this).next(".next");
        var numInList = list.length;
        list.hide();
        if (numInList > numToShow) {
            button.show();
        }
        list.slice(0, numToShow).show();

        button.click(function(e){
            e.preventDefault();
            var showing = list.filter(':visible').length;
            list.slice(showing, showing + numToShow).fadeIn();
            var nowShowing = list.filter(':visible').length;
            if (nowShowing >= numInList) {
                button.hide();
            }
        });
    });
});